<template>
	<div v-if="form.progress" class="bg-transparent px-2 pt-2 pb-4 lg:pt-8 lg:pb-5">
		<div
			class="bg-progressbar tall:lg:h-3 flex h-1 w-full items-center overflow-visible rounded-2xl md:h-2"
		>
			<div
				:style="`width: ${form.progress}%;`"
				class="bg-progressbarActive tall:lg:max-w-[95%] relative h-full rounded-2xl transition-all duration-1000"
			>
				<template v-if="iconObject">
					<BeetleSvg
						v-if="iconObject.icon === 'beetle'"
						v-model="form.progress"
						v-bind="iconObject"
						class="tall:lg:min-w-[114px] tall:lg:max-w-[200%] absolute right-0 top-2 h-11 w-16 translate-x-1/2 -translate-y-2/3 md:w-20"
					/>
					<CarSvg
						v-if="iconObject.icon === 'fiat'"
						v-model="form.progress"
						v-bind="iconObject"
						class="tall:lg:h-12 tall:lg:min-w-[114px] tall:lg:max-w-[200%] absolute right-0 top-2 h-9 w-16 translate-x-1/2 -translate-y-2/3 md:w-20"
					/>
				</template>
				<CarSvg
					v-else
					v-model="form.progress"
					class="tall:lg:h-12 tall:lg:min-w-[114px] tall:lg:max-w-[200%] absolute right-0 top-2 h-9 w-16 translate-x-1/2 -translate-y-2/3 md:w-20"
				/>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { useFormStore } from '../../../stores/form'
	import CarSvg from './icons/CarSvg.vue'
	import { ProgressbarIcon, useConfigStore } from '../../../stores/config'
	import BeetleSvg from './icons/BeetleSvg.vue'
	import { computed } from 'vue'

	const form = useFormStore()
	const config = useConfigStore()

	const iconObject = computed(() => {
		const icon = config.getConfigContent<ProgressbarIcon | null>('progressbarIcon', null)

		return icon?.icon && icon
	})
</script>
